/* globals Accordion, Cammio */
import 'lib/accordion'

window['candidates/interviews#index'] = function () {
  Accordion.init()

  const panels = document.getElementsByClassName('accordion-panel')
  panels.forEach(panel => {
    panel.addEventListener('accordion_open', e => {
      const interviewId = e.target.dataset.id
      const container = e.target.getElementsByClassName('video-container')[0]
      const url = new URL(`${document.location.origin}/${document.location.pathname}/${interviewId}`)

      fetch(url, { method: 'GET' })
        .then(function (response) {
          switch (response.status) {
            case 200:
              return response.json()
            default:
              throw response
          }
        })
        .then(function (data) {
          const div = document.createElement('div')
          div.setAttribute('id', 'cammio-video-player')
          container.appendChild(div)
          Cammio.createPlayerWidget({
            id: data.id,
            token: data.token
          })
        })
        .catch(function (response) {
          console.log(response.statusText)
        })
    })

    panel.addEventListener('accordion_close', e => {
      const container = e.target.getElementsByClassName('video-container')[0]
      container.innerHTML = ''
    })
  })
}
